import React from 'react'
import {useNavigate} from 'react-router-dom';

const Home = () => {
  // const params = useParams();
  const navigate = useNavigate();
  return (
    <div>
      <header>
    <div className="container">
        <article>
            <h1>An online clothing store where you can discover everything you imagine at the best prices!</h1>
            <p>We are excited to introduce our new collection and delighted to have you visit our page.</p>
            <button onClick={() => navigate("/products")}>Discover our products </button>
        </article>
    </div>
</header>
    </div>
  )
}

export default Home
{/* <button onClick={() => navigate("/")}>Check out</button> */}